import { deskToRect } from 'src/components/DeskPlace/DeskPlace';
import { parkingToRect } from 'src/components/ParkingPlace/ParkingPlace';
import { roomToCircle } from 'src/components/RoomPlace/RoomPlace';
import {
  BookingObject,
  Desk,
  GeometryForm,
  Parking,
  PlaceType,
  Room,
} from 'src/types';

import { hasIntersection } from './hasIntersection';

interface GetGeometryFormByBookingObjectType {
  [PlaceType.Desk]: (desk: Desk) => GeometryForm;
  [PlaceType.Room]: (room: Room) => GeometryForm;
  [PlaceType.Parking]: (parking: Parking) => GeometryForm;
}

const getGeometryFormByBookingObjectType: GetGeometryFormByBookingObjectType = {
  [PlaceType.Desk]: deskToRect,
  [PlaceType.Room]: roomToCircle,
  [PlaceType.Parking]: parkingToRect,
};

export const hasCollisions = (
  active: BookingObject,
  other: BookingObject[],
): boolean => {
  const activeForm = getGeometryFormByBookingObjectType[active.type](
    active as any,
  );

  for (const collidable of other) {
    const collidableForm = getGeometryFormByBookingObjectType[collidable.type](
      collidable as any,
    );

    const collide = hasIntersection(activeForm, collidableForm);

    if (collide) return true;
  }

  return false;
};
